let redirectPromise = null

export function redirectToLogin(router) {
    if(redirectPromise) return redirectPromise

    if(router.currentRoute.path === '/login') {
        return Promise.resolve()
    }
    const uri = encodeURI(location.pathname)
    redirectPromise = router.replace(`/login?redirect=${uri}`)
            .finally(() => redirectPromise = null)
    
    return redirectPromise
}